export const CARD_WIDTH = 280;
